import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    // Add structured data for LocalBusiness
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Gofragt.dk",
      "description": "Hurtig og pålidelig kurérservice fra Århus med 10 års erfaring",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Silkeborgvej 26A",
        "addressLocality": "Århus C",
        "addressRegion": "Århus",
        "postalCode": "8000",
        "addressCountry": "DK"
      },
      "telephone": "+45 21 56 35 52",
      "email": "mikkelrisum@hotmail.dk",
      "url": import.meta.env.VITE_SITE_URL || "https://gofragt.dk",
      "openingHours": "Mo-Su 00:00-24:00",
      "priceRange": "Konkurrencedygtige priser",
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": 56.1629,
          "longitude": 10.2039
        },
        "geoRadius": "500000"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Kurérservice",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ekspres Levering",
              "description": "Hurtig ekspres levering"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Service",
              "name": "Samme-dag Levering",
              "description": "Levering samme dag"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "48 Timer Levering",
              "description": "Levering inden for 48 timer"
            }
          }
        ]
      }
    };

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvor hurtigt kan I levere?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Vi tilbyder ekspres levering, samme-dag levering og levering inden for 48 timer afhængigt af dine behov."
          }
        },
        {
          "@type": "Question", 
          "name": "Hvilke områder dækker I?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Vi leverer til hele Danmark med base i Århus. Vi har 10 års erfaring med kurérservice."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan kan jeg kontakte jer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ring til os på 21 56 35 52 - vi har 24/7 telefon service. Du kan også sende en email til mikkelrisum@hotmail.dk."
          }
        }
      ]
    };

    // Remove existing structured data scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    // Add new structured data
    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json'; 
    script2.textContent = JSON.stringify(faqData);
    document.head.appendChild(script2);

    return () => {
      // Cleanup on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <Features />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
